<template>
  <div
    v-if="props.value && isDelayedLoading"
    v-bind="$attrs"
    :class="{
      'e-circular-loading': true,
      'e-circular-loading--full-page': fullPage,
    }">
    <v-progress-circular
      v-bind="$props"
      :indeterminate="props.indeterminate"
      :size="props.fullPage ? 50 : props.size"
      :color="props.color"
      :width="props.width"
      bg-color="transparent" />
  </div>
</template>

<script setup>
import { onBeforeUnmount, ref, watch } from 'vue'
import { VProgressCircular } from 'vuetify/components/VProgressCircular'
import { useDeprecatedProps } from '../../composables/useDeprecatedProps'
import { loadingProps, useDelayedLoader } from '../../composables/useLoading'

const props = defineProps({
  value: {
    type: Boolean,
    default: true,
  },
  color: {
    type: String,
    default: 'primary300',
  },
  fullPage: {
    type: Boolean,
    default: false,
  },
  indeterminate: {
    type: Boolean,
    default: true,
  },
  size: {
    type: [Number, String],
    default: undefined,
  },

  width: {
    type: [Number, String],
    default: undefined,
  },
  ...loadingProps,
  // deprecated
  timeout: {
    type: Number,
    default: undefined,
  },
})

useDeprecatedProps(
  props,
  {
    timeout: 'Use "delay" instead.',
  },
  'ECircularLoading'
)

const { isDelayedLoading, showLoading, hideLoading } = useDelayedLoader(props.delay)

watch(
  () => props.value,
  (v) => {
    if (v) {
      showLoading()
    } else {
      hideLoading()
    }
  },
  { immediate: true }
)

// const show = ref(false)
// const timer = ref(null)

// const destroyTimer = () => {
//   timer.value && clearTimeout(timer.value)
//   timer.value = null
//   show.value = false
// }

// watch(
//   () => props.value,
//   () => {
//     destroyTimer()
//     if (props.value) {
//       if (props.delay > 0) {
//         timer.value = setTimeout(() => (show.value = true), props.delay)
//       } else show.value = true
//     }
//   },
//   { immediate: true }
// )

// onBeforeUnmount(() => {
//   destroyTimer()
// })
</script>

<style lang="scss">
@import '../../scss/styles';

.e-circular-loading {
  $el: &;
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;

  &#{$el}--full-page {
    width: 100vw;
    height: 100vh;
    position: fixed;
    z-index: 999;
    background: $whitebase;
  }
}
</style>
